export default __webpack_public_path__ + "static/media/top-image-popup.f70cf385.png";